<template>
    <div ref="paymentRequestButtons" class="platformPayment" v-if="canMakePayment">
    </div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js';

export default {
    data() {
        return {
            stripe: null,
            canMakePayment: false,
            inited: false,
        };
    },
    props: {
        paymentMode: { type: String, default: 'payment' },
        stripePaymentIntentApiUrl: { type: String },
    },

    methods: {
        async _canMakePayment() {
            // We need a pseudo payment request here, to check whether Apple Pay or Google Pay is available. This
            // check is impossible with a payment intent, unfortunately.
            const payment = this.stripe.paymentRequest({
                currency: 'eur',
                country: 'DE',
                total: {
                    label: 'Wookiee Boots',
                    amount: 1000,
                },
            });

            const result = await payment.canMakePayment();

            if (result === null) {
                return false;
            }

            return result.googlePay || result.applePay;
        },
    },

    watch: {
        canMakePayment(val) {
            if (!val || this.inited) {
                return;
            }
            this.inited = true;

            fetch(this.stripePaymentIntentApiUrl)
                .then(response => response.json())
                .then(data => {
                    const elements = this.stripe.elements({
                        clientSecret: data.stripeClientSecret,
                        apperance: {
                            theme: 'night',
                            variables: {
                                borderRadius: '5px',
                            },
                        },
                    });

                    const checkoutElement = elements.create('expressCheckout', {
                        buttonType: {
                            applePay: this.paymentMode === 'subscription' ? 'subscribe' : 'buy',
                            googlePay: this.paymentMode === 'subscription' ? 'subscribe' : 'buy',
                        },
                        buttonTheme: {
                            applePay: 'black',
                            googlePay: 'black',
                        },
                        buttonHeight: 50,
                    });

                    this.$nextTick(() => {
                        checkoutElement.mount(this.$refs.paymentRequestButtons);

                        checkoutElement.on('ready', () => {
                            setTimeout(() => this.$emit('loaded', false), 200);
                        });

                        checkoutElement.on('confirm', async () => {
                            const {error: submitError} = await elements.submit();
                            if (submitError) {
                                return;
                            }

                            const { error } = await this.stripe.confirmPayment({
                                elements: elements,
                                clientSecret: data.stripeClientSecret,
                                confirmParams: {
                                    return_url: data.stripeReturnUrl,
                                },
                            });

                            if (error) {
                                this.canMakePayment = false;
                            }
                        });

                        setTimeout(() => this.$emit('loaded', false), 200);
                    });
                })
                .catch(() => {
                    this.canMakePayment = false;
                    setTimeout(() => this.$emit('loaded', false), 200);
                });
        },
    },

    async mounted() {
        if (STRIPE_PK === undefined || STRIPE_API_VERSION === undefined) {
            setTimeout(() => this.$emit('loaded', false));

            return;
        }

        this.stripe = await loadStripe(STRIPE_PK, {
            apiVersion: STRIPE_API_VERSION,
        });

        this.isReady = true;

        this.canMakePayment = await this._canMakePayment();

        if (!this.canMakePayment) {
            setTimeout(() => this.$emit('loaded', false));

            return;
        }
    },
};
</script>

<style scoped>
    .platformPayment {
        min-height: 58px;
    }
</style>
